// Basemap próprio, servido pela própria origem (/tiles/) a partir da stack
// /opt/stacks/basemap na bee.
//
// Trocou a CARTO, que em 2026 passou a exigir chave nos tiles raster e carimba
// "API KEY REQUIRED / carto.com/basemaps/apikey" em diagonal dentro do PNG.
// Ela não bloqueia nem devolve erro — HTTP 200, imagem válida, carimbo por cima
// do mapa. Falha silenciosa: não aparece em log nenhum.
//
// Os estilos são positron e dark-matter, que são a ORIGEM do light_all e do
// dark_all que estavam aqui (a CARTO abriu os dois). Não é "parecido": é o
// mesmo desenho, agora renderizado em casa a partir do OpenStreetMap.
//
// A URL é RELATIVA de propósito. É isso que permite trocar o destino do
// basemap das duas praças pelo nginx (/opt/stacks/basemap/cache.conf) em
// segundos, sem rebuild e sem deploy, se algo der errado.

// Sufixo retina. Cada tile @2x custa ~4x de CPU no render server-side, então
// entra desligado e só liga depois de medir. NÃO usar o `detectRetina` do
// Leaflet no lugar disto: ele divide o tileSize por 2, mexe no zoomOffset e
// DOBRA a contagem de tiles pedidos — exatamente o que não se quer com render
// próprio.
const RETINA = ''

export const basemapUrl = (dark = false) =>
  `/tiles/${dark ? 'dark-matter' : 'positron'}/{z}/{x}/{y}${RETINA}.png`

// Atribuição obrigatória, em DUAS camadas — as duas são exigidas:
//
//   ODbL      o tile é "Produced Work" de dado OpenStreetMap: crédito aos
//             contribuidores + link para a licença, visíveis no mapa.
//   CC-BY     os tiles são gerados com o perfil OpenMapTiles do planetiler, e
//             a licença do schema deles pede crédito visível. O próprio
//             planetiler imprime a exigência no fim do build:
//             "must display a visible credit: © OpenMapTiles © OpenStreetMap contributors"
//
// O "© CARTO" saiu junto com o tile deles.
export const BASEMAP_ATTRIB =
  '&copy; <a href="https://openmaptiles.org/" target="_blank" rel="noreferrer">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors'

// Versão em texto puro, para os mapas decorativos das landings, onde o controle
// de atribuição do Leaflet não cabe no cartão e o crédito vai numa linha logo
// abaixo do mapa.
export const BASEMAP_ATTRIB_TEXT = '© OpenMapTiles © OpenStreetMap'
